import { ShortSpecification } from '@components/display/offer/ShortSpecifications'

import styles from 'styles/OfferShortSpecifications.module.css'
import stylesAlt from 'styles/OfferShortSpecificationsAlt.module.css'

const ShortSpecificationsAlt = ({ offer: { category, subcategory, kind }}) => {
    return (
        <div className={`${styles.specs} ${stylesAlt.specs}`}>
            <ShortSpecification value={category} alt="Kategoria" showtext={true} />
            <ShortSpecification value={subcategory} alt="Podkategoria" showtext={true} />
            <ShortSpecification value={kind} alt="Rodzaj" showtext={true} />
        </div>
    )
}

export default ShortSpecificationsAlt